import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductsListComponent } from './products-list/products-list.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { ContactComponent } from './contact/contact.component';
import { LayoutComponent } from './layout/layout.component';
import { ProductRedirectComponent } from './product-redirect/product-redirect.component';
import { Page404Component } from '../shared/page404/page404.component';
import { PrzerwaComponent } from '../przerwa/przerwa.component';

const routes: Routes = [
  {
    path: 'fusio-dose-w-naszym-salonie',
    loadChildren: () =>
      import('./lp/fusio-dose-w-naszym-salonie/fusio-dose-w-naszym-salonie.module').then(
        (m) => m.FusioDoseWNaszymSalonieModule,
      ),
  },
  {
    path: 'fryzjerstwo-dla-przyszlosci',
    loadChildren: () =>
      import('../consumer/lp/hairdressing-for-the-future/hairdressing-for-the-future.module').then(
        (m) => m.HairdressingForTheFutureModule,
      ),
  },
  {
    path: 'fryzjerstwo-dla-przyszlosci-prasa',
    loadChildren: () =>
      import('../consumer/lp/hairdressing-for-the-future-press/hairdressing-for-the-future-press.module').then(
        (m) => m.HairdressingForTheFuturePressModule,
      ),
  },
  {
    path: 'live-new-curl-expression',
    loadChildren: () =>
      import('../consumer/lp/live-new-curl-expression/live-new-curl-expression.module').then(
        (m) => m.LiveNewCurlExpressionModule,
      ),
  },
  {
    path: 'kerastase-genesis-homme',
    loadChildren: () =>
      import('../consumer/lp/kerastase-genesis-homme/kerastase-genesis-homme.module').then(
        (m) => m.KerastaseGenesisHommeModule,
      ),
  },
  {
    path: 'kerastase-blond-absolu',
    loadChildren: () =>
      import('../consumer/lp/kerastase-blond-absolu/kerastase-blond-absolu.module').then(
        (m) => m.KerastaseBlondAbsoluModule,
      ),
  },
  {
    path: 'kerastase-symbiose',
    loadChildren: () =>
      import('./lp/kerastase-symbiose/kerastase-symbiose.module').then((m) => m.KerastaseSymbioseModule),
  },
  {
    path: 'salon-iframe',
    loadChildren: () => import('./find-salon/find-salon.module').then((m) => m.FindSalonModule),
    data: {
      newWindow: true,
    },
  },
  {
    path: 'cookies-policy',
    loadChildren: () =>
      import('../consumer/lp/cookies-policy/cookies-policy.module').then((m) => m.CookiesPolicyModule),
  },

  {
    path: 'testowaniekerastase',
    loadChildren: () => import('../consumer/lp/kerastase-lp/kerastase-lp.module').then((m) => m.KerastaseLpModule),
  },
  {
    path: 'testowaniekerastase_newsletter',
    loadChildren: () =>
      import('../consumer/lp/kerastase-newsletter/kerastase-newsletter.module').then(
        (m) => m.KerastaseNewsletterModule,
      ),
  },

  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'tabelaows',
        loadChildren: () => import('../pages/main/pages/tabelaows/tabelaows.module').then((m) => m.TabelaowsModule),
      },
      {
        path: 'biznes',
        component: PrzerwaComponent,
        children: [
          {
            path: '**',
            redirectTo: '/biznes',
            pathMatch: 'full',
          },
        ],
      },
      // {
      //   path: 'fryzjerstwo-dla-przyszlosci-2',
      //   loadChildren: () => import('../consumer/lp/hairdressing-for-the-future/hairdressing-for-the-future-routing.module')
      //     .then(m => m.HairdressingForTheFutureRoutingModule)
      // },
      {
        path: '404',
        component: Page404Component,
      },
      {
        path: 'pride-month',
        loadChildren: () =>
          import('./lp/kerastase-x-stonewall/kerastase-x-stonewall.module').then((m) => m.KerastaseXStonewallModule),
      },
      {
        path: 'loreal_dla_przyszlosci',
        loadChildren: () =>
          import('./lp/haircut-future-streaming/haircut-future.module').then((m) => m.HairCutFutureModule),
      },

      {
        path: 'se-akademia',
        loadChildren: () => import('./lp/se-academy/se-academy.module').then((m) => m.SEAcademyModule),
      },
      {
        path: 'rendez-vous',
        loadChildren: () => import('./lp/randez-vous/randez-vous.module').then((m) => m.RandezVousModule),
      },
      {
        path: 'testowanielorealpro',
        loadChildren: () => import('../consumer/lp/loreal-lp/loreal-lp.module').then((m) => m.LorealLpModule),
      },
      // kontakt
      {
        path: 'kontakt',
        component: ContactComponent,
        data: {
          title: 'Kontakt',
        },
      },
      {
        path: `ankieta/:id`,
        redirectTo: '/',
      },
      // tv
      {
        path: 'salon-expert-tv',
        loadChildren: () => import('./tv/tv.module').then((m) => m.TvModule),
        // loadChildren: './tv/tv.module#TvModule',
        data: {
          title: 'Salon Expert TV',
        },
      },
      // artykuły
      // {
      //   path: 'artykuly',
      //   loadChildren: () =>
      //     import('./articles/articles.module').then((m) => m.ArticlesModule),
      //   data: {
      //     title: 'Artykuły',
      //   },
      // },
      // aktualnosci
      // {
      //   path: 'aktualnosci',
      //   loadChildren: './news/news.module#NewsModule',
      //   data: {
      //     title: 'Aktualności'
      //   },
      // },
      // diagnoza
      {
        path: 'diagnoza',
        loadChildren: () => import('./diagnostic/diagnostic.module').then((m) => m.DiagnosticModule),
        // loadChildren: './diagnostic/diagnostic.module#DiagnosticModule',
        data: {
          title: 'Diagnoza Włosa',
        },
      },
      // salony
      {
        path: 'salon',
        loadChildren: () => import('./find-salon/find-salon.module').then((m) => m.FindSalonModule),
        // loadChildren: './find-salon/find-salon.module#FindSalonModule',
        data: {
          title: 'Salony',
        },
      },
      // produkty
      {
        path: 'produkt/:slug',
        component: ProductDetailsComponent,
      },
      {
        path: 'produkty',
        data: {
          title: 'Produkty',
        },
        children: [
          {
            path: 'pielegnacja',
            redirectTo: '/artykuly?tag=Pielęgnacja',
          },
          {
            path: '',
            component: ProductsListComponent,
          },
          {
            path: ':category',
            children: [
              {
                path: ':slug',
                component: ProductRedirectComponent,
              },
              {
                path: '',
                component: ProductsListComponent,
              },
            ],
          },
        ],
      },
      // produkty - efekty
      {
        path: 'efekty',
        data: {
          title: 'Efekty',
        },
        children: [
          {
            path: '',
            component: ProductsListComponent,
          },
          {
            path: ':category',
            children: [
              {
                path: ':slug',
                component: ProductRedirectComponent,
              },
              {
                path: '',
                component: ProductsListComponent,
              },
            ],
          },
        ],
      },
      // produkty - gamy
      {
        path: 'gamy',
        data: {
          title: 'Gamy',
        },
        children: [
          {
            path: '',
            component: ProductsListComponent,
          },
          {
            path: ':category',
            children: [
              {
                path: ':slug',
                component: ProductRedirectComponent,
              },
              {
                path: '',
                component: ProductsListComponent,
              },
            ],
          },
        ],
      },
      // szukaj
      {
        path: 'szukaj',
        loadChildren: () => import('./search/search.module').then((m) => m.SearchConsumerModule),
        // loadChildren: './search/search.module#SearchConsumerModule',
        data: {
          title: 'Wyszukiwarka',
        },
      },
      // homepage
      {
        path: '',
        loadChildren: () => import('./homepage/homepage.module').then((m) => m.HomepageModule),
        // loadChildren: './homepage/homepage.module#HomepageModule',
        data: {
          title: 'Strona główna',
        },
      },
      // inne
      {
        path: '**',
        loadChildren: () => import('./page/page.module').then((m) => m.PageModule),
        // loadChildren: './page/page.module#PageModule'
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ConsumerRoutingModule {}
